// Imports from node_modules, installed via 'yarn add ...'
// Bootstrap: selective component imports (2026-07 JS audit). Each dist module
// registers its own data-API on import. Excluded as unused in theme markup
// and JS: Carousel (Swiper covers it), Tooltip, Popover, ScrollSpy, Button.
// Re-enable by importing the module and adding it to window.bootstrap below.
// All three are still genuinely used: Alert by a dismissible alert, Tab by the
// switcher section's tab panes, Toast by the cart/wishlist notifications. Audited
// 2026-08-06 when Dropdown went; nothing here is dead.
//
// `@popperjs/core` stays in package.json despite nothing importing it: Bootstrap
// 5.2.3 declares it as a REQUIRED (non-optional) peer dependency, so removing it
// only buys a yarn peer warning on every install of this theme and every project
// cloned from it. It is not in the bundle either way. Drop it when Bootstrap JS
// goes entirely.
import Alert from 'bootstrap/js/dist/alert';
// Collapse retired 2026-08-05: accordions are native details/summary, the
// header search is a popover, and simple reveals use data-disclosure-target
// (disclosures.js). See CHANGELOG.
// Dropdown retired 2026-08-06 (phases 1-3 of the Popper removal): the hover
// megamenus never used it, the click menus are extensions/menus.js, and the
// localization dropup is a native popover. @popperjs/core left with it.
import Tab from 'bootstrap/js/dist/tab';
import Toast from 'bootstrap/js/dist/toast';

const bootstrap = { Alert, Tab, Toast };

import 'waypoints/lib/noframework.waypoints.min.js'; // Waypoints (intersection observer utility) (~10Kb)
import Cookies from 'js-cookie'; // Cookies.js (~2Kb)

// import TomSelect from 'tom-select'; // TomSelect (~52Kb) - now dynamically imported via theme.js
// import AOS from 'aos'; // Animate on Scroll (~14Kb) - now dynamically imported via extensions/aos-init.js
// import PhotoSwipe from 'photoswipe'; // PhotoSwipe (~56Kb) - now dynamically imported via extensions/product-photoswipe.js
// import Swiper, { Navigation, Pagination, Autoplay, Thumbs } from 'swiper'; // now dynamically imported via elements/swiper-slider.js
// import Swiper from 'swiper'; - now dynamically imported via elements/swiper-slider.js
// import { Navigation, Pagination, Autoplay, Thumbs } from 'swiper/modules'; - now dynamically imported via elements/swiper-slider.js
// import Masonry from 'masonry-layout'; // Masonry (~8Kb)

// Swiper.use([Navigation, Pagination, Autoplay, Thumbs]); - now dynamically imported via elements/swiper-slider.js

// Export for others scripts to use by attaching to the window
window.bootstrap = bootstrap;
window.Cookies = Cookies;

// window.TomSelect = TomSelect; - now dynamically imported via theme.js
// window.Swiper = Swiper; - now dynamically imported via elements/swiper-slider.js
// window.PhotoSwipe = PhotoSwipe; - now dynamically imported via extensions/product-photoswipe.js

// window.Masonry = Masonry;

// Initialisation
// AOS.init({
//   once: true
// });